import React from 'react';
import { useAppSelector } from '../../../../app/hooks';
import { mainColourSelector } from '../../../chatbotSlice';

interface LoadingSpinnerProps {
  message?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  message = 'Loading vehicle details...' 
}) => {
  const mainColour = useAppSelector(mainColourSelector);
  
  return (
    <div className="flex flex-col justify-center items-center h-64">
      <div className="relative w-16 h-16">
        <div 
          className="absolute top-0 left-0 w-full h-full rounded-full border-4 border-t-transparent animate-spin"
          style={{ borderColor: `${mainColour} transparent transparent transparent` }}
        ></div>
      </div>
      <p className="mt-4 text-gray-600 font-medium">{message}</p>
    </div>
  );
};
